import { useMediaQuery, useTheme } from "@mui/material";
import { isNative } from "../lib/platform";

/**
 * Whether to present surfaces in the touch idiom (bottom sheets) rather than
 * the pointer idiom (anchored menus and centred dialogs).
 *
 * Keyed on viewport *and* native — mobile web is just as touch-driven as the
 * app, so gating on isNative() alone would leave mobile Safari with desktop
 * popovers. Haptics and safe-area padding still gate on isNative() separately.
 */
export const useTouchLayout = (): boolean => {
  const theme = useTheme();
  const isSmallViewport = useMediaQuery(theme.breakpoints.down("md"));
  return isSmallViewport || isNative();
};
